export default __webpack_public_path__ + "assets/images/4959b232650d1d4ec9e88562491eba78.svg";